import React, { FC } from 'react';
import './style.scss';
import { TFadeProps } from './types/fade.type';

const FadeDown: FC<TFadeProps> = ({ children, delay, duration }) => {
  return (
    <div className="fadeInUp" style={{ animationDelay: `${delay}ms`, animationDuration: `${duration}ms` }}>
      {children}
    </div>
  );
};

export default FadeDown;
